import { apiClient } from './ApiClient'
import {
  TicketEscalation,
  EscalationPath,
  CreateEscalationRequest,
  CreateEscalationPathRequest,
  UpdateEscalationPathRequest,
} from '../types/entities'

export const EscalationService = {
  // Ticket Escalations
  async getTicketEscalations(ticketId: string): Promise<TicketEscalation[]> {
    return apiClient.get<TicketEscalation[]>(`/escalations/ticket/${ticketId}`)
  },

  async getEscalationsByUser(): Promise<TicketEscalation[]> {
    return apiClient.get<TicketEscalation[]>('/escalations/user/escalated-by')
  },

  async getEscalationsToUser(): Promise<TicketEscalation[]> {
    return apiClient.get<TicketEscalation[]>('/escalations/user/escalated-to')
  },

  async createEscalation(request: CreateEscalationRequest): Promise<TicketEscalation> {
    return apiClient.post<TicketEscalation, CreateEscalationRequest>('/escalations', request)
  },

  // Escalation Paths (SLA Rules)
  async getEscalationPaths(): Promise<EscalationPath[]> {
    return apiClient.get<EscalationPath[]>('/escalation-paths')
  },

  async getEscalationPath(pathId: string): Promise<EscalationPath> {
    return apiClient.get<EscalationPath>(`/escalation-paths/${pathId}`)
  },

  async createEscalationPath(request: CreateEscalationPathRequest): Promise<EscalationPath> {
    return apiClient.post<EscalationPath, CreateEscalationPathRequest>('/escalation-paths', request)
  },

  async updateEscalationPath(pathId: string, request: UpdateEscalationPathRequest): Promise<EscalationPath> {
    return apiClient.put<EscalationPath, UpdateEscalationPathRequest>(`/escalation-paths/${pathId}`, request)
  },

  async deleteEscalationPath(pathId: string): Promise<void> {
    return apiClient.delete<void>(`/escalation-paths/${pathId}`)
  },
}
